import React, { useState } from 'react';
import { CardContent, IconButton, Stack, Paper, Tooltip, OpenInNewIcon, CropSquareIcon } from "../../styles/MaterialUI";
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Draggable from 'react-draggable';
import Troubleshoot from './Troubleshoot';
import { useDispatch, useSelector } from 'react-redux';
import { closeTroubleshoot } from '../Redux/Features/reloadMetricsSlice';

const TroubleShootLayout = () => {
    const dispatch = useDispatch();
    const { isTroubleshootOpen } = useSelector((state) => state.reloadMetrics);
    const [dimension, setDimension] = useState({ width: 500, height: 500 });
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [disableCallOut, setDisableCallOut] = useState(false);

    const handleDrag = (e, data) => {
        setDimension(prev => ({ ...prev, width: Math.max(500, prev.width + data.deltaX), height: Math.max(500, prev.height + data.deltaY) }));
    };

    const handleDragStop = (e, data) => {
        setPosition({ x: data.x, y: data.y });
    };

    const handleMinimizeMaximize = () => {
        if (dimension.height === 35) {
            setDimension({ width: 500, height: 500 });
        } else {
            setDimension({ width: 500, height: 35 });
        }
        setPosition({ x: 15, y: 1 });
    };

    const handleMaximize = () => {
        dispatch(closeTroubleshoot());
        window.open('/troubleshoot', '_blank');
    };

    const handleCloseWindow = () => {
        dispatch(closeTroubleshoot());
        setDisableCallOut(false);
    }

    const handleDisableCallOut = (value) => {
        setDisableCallOut(value);
    }

    return (
        isTroubleshootOpen ?
            <Draggable onStop={handleDragStop} position={position}>
                <Paper style={{
                    color: "#003366", padding: "5px", position: "absolute", right: "15px", bottom: "1px", zIndex: 1101, overflow: "hidden",
                    width: `${dimension.width}px`, height: `${dimension.height}px`,
                    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'
                }}>
                    <Stack direction="row" display="flex" justifyContent="space-between" alignItems="center"
                        sx={{
                            "&:hover": { cursor: "grab" },
                            backgroundColor: "#003366", padding: "5px", margin: "-5px -5px 0 -5px", position: "relative", zIndex: 1,
                        }}>
                        <h4 style={{ color: "#ffffff", margin: "0 0 0 10px", width: "100%", textAlign: "left", position: "sticky" }}>Troubleshoot</h4>
                        <Tooltip title={dimension.height === 35 ? "Maximize" : "Minimize"}>
                            <IconButton aria-label="ExpandCollapseCard" size='small' onClick={handleMinimizeMaximize} sx={{ color: "#ffffff" }}>
                                {dimension.height === 35 ? <CropSquareIcon /> : <RemoveIcon fontSize='small' />}
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Open in New Tab">
                            <IconButton aria-label="ExpandCollapseCard" size='small' onClick={handleMaximize} disabled={disableCallOut} sx={{ color: "#ffffff" }}>
                                <OpenInNewIcon fontSize='small' />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Close">
                            <IconButton aria-label="ExpandCollapseCard" size='small' onClick={handleCloseWindow} sx={{ color: "#ffffff" }}>
                                <CloseIcon fontSize='small' />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    <CardContent style={{ marginTop: "-10px", paddingBottom: "5px", overflow: "auto", height: "calc(100% - 50px)" }}>
                        <Stack sx={{ width: '100%' }} spacing={1}>
                            <Troubleshoot disableCallOut={handleDisableCallOut} />
                        </Stack>
                    </CardContent>
                    <Draggable axis='both' onDrag={handleDrag} position={{ x: 0, y: 0 }}
                        onStop={(e) => {
                            e.stopPropagation();
                        }}>
                        <div className="drag-handle" style={{ position: 'absolute', bottom: 0, right: 0, cursor: 'nwse-resize' }}>
                            {dimension.height !== 35 && <DragIndicatorIcon />}
                        </div>
                    </Draggable>
                </Paper>
            </Draggable > : null
    )
}

export default TroubleShootLayout;
